import { useState } from "react";
import { es } from "date-fns/locale";
import { CalendarDays, X } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { isoDay } from "@/components/training/trainingUtils";

const toDate = (iso) => { if (!iso) return undefined; const [y, m, d] = iso.split("-").map(Number); return new Date(y, m - 1, d); };
const display = (iso) => (iso ? toDate(iso).toLocaleDateString("es-ES", { day: "2-digit", month: "2-digit", year: "numeric" }) : "");

export const DateField = ({ value, onChange, min, testid, placeholder = "dd/mm/aaaa" }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className="w-full h-10 rounded-md border border-input bg-white px-3 text-sm text-left flex items-center gap-2 hover:border-[#1A1A1A] transition-colors">
          <CalendarDays className="h-4 w-4 text-[#8A7E70] shrink-0" />
          <span className={`flex-1 truncate ${value ? "text-[#1A1A1A]" : "text-[#A79E90]"}`}>{display(value) || placeholder}</span>
          {value && (
            <span role="button" data-testid={`${testid}-clear`} onClick={(e) => { e.stopPropagation(); onChange(""); }} className="text-[#A79E90] hover:text-[#1A1A1A]"><X className="h-3.5 w-3.5" /></span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" locale={es} weekStartsOn={1} selected={toDate(value)} defaultMonth={toDate(value) || toDate(min)}
          disabled={min ? { before: toDate(min) } : undefined}
          onSelect={(d) => { onChange(d ? isoDay(d) : ""); setOpen(false); }} />
      </PopoverContent>
    </Popover>
  );
};
